import React, { useState, useCallback } from "react";
import { MenuSection } from "../../src/model/common";

const defaultApi = {
  sidebarCollapsed: false,
  toggleSidebar: () => {
    // method to set collapsed flag for the sidebar
  },
  openedMenuSectionIndex: -1,
  setOpenedMenuSectionIndex: (index: number) => {
    // method to set the current opened menu section index.
  },
  firstSectionInitialOpen: false,
  setFirstSectionInitialOpen: (opened: boolean) => {
    // method to set firstSectionInitialOpen
  },
  allSidebarSectionsPopulated: false,
  setAllSidebarSectionsPopulated: (populated: boolean) => {
    // method to set allSidebarSectionsPopulated
  },
  menu: [] as MenuSection[],
  setMenu: (menu: MenuSection[]) => {
    // method to set menu items
  }
};

export const LayoutContext = React.createContext(defaultApi);

export function LayoutProvider({ children }: any) {

  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    defaultApi.sidebarCollapsed
  );

  const [openedMenuSectionIndex, setOpenedMenuSectionIndex] = useState(
    defaultApi.openedMenuSectionIndex
  )

  const [menu, setMenu] = useState(defaultApi.menu)
  const [firstSectionInitialOpen, setFirstSectionInitialOpen] = useState(false)
  const [allSidebarSectionsPopulated, setAllSidebarSectionsPopulated] = useState(false)

  const setSidebarMenu = (menu: MenuSection[]) => {
    setFirstSectionInitialOpen(false)
    setOpenedMenuSectionIndex(-1)
    setAllSidebarSectionsPopulated(false)
    setMenu(menu)
  }
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  return (
    <LayoutContext.Provider
      value={{
        sidebarCollapsed,
        toggleSidebar,
        openedMenuSectionIndex,
        setOpenedMenuSectionIndex,
        menu,
        setMenu: setSidebarMenu,
        firstSectionInitialOpen,
        setFirstSectionInitialOpen,
        allSidebarSectionsPopulated,
        setAllSidebarSectionsPopulated
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
}
